import { filter } from 'rxjs/operators';
/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Component, Input, Output, EventEmitter, OnChanges, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../../core/common/common.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';
import { pluck } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ListsService } from 'src/core/lists/lists.service';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'app-category-list',
    templateUrl: './category-list.component.html',
    styleUrls: ['./category-list.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state('open', style({ height: '*' })),
            state('closed', style({ height: '0px' })),
            transition('open <=> closed', animate('500ms ease-in-out')),
        ])
    ]
})
export class CategoryListComponent implements OnChanges, OnInit, OnDestroy, DoCheck {
    // decorator
    @Input() categories;
    @Input() sidecategories;
    @Input() categoryId;
    @Input() changeCategories;
    @Input() isClicked = [];
    @Output() change: EventEmitter<any> = new EventEmitter();
    // categories
    mainCategories;
    public subCategory = [];
    // categories selected
    public activecategory: any;
    public currentCategory: any;
   
    // subscriptions
    private subscriptions: Array<Subscription> = [];
    public categorySlug: any;
    @Input() categoryParentId;
    filteredArray: any[] = [];
    Category: any[] = [];
    SideCategory: any[] = [];
    showSubcategories: boolean[] = [];
    visible:boolean=false;
    specialDealValue: string;
    constructor(public listSandBox: ListsSandbox, private commonService: CommonService,
        public route: ActivatedRoute,
        public router: Router,
        private listsService: ListsService) {
        this.subscribe();
    }

    ngOnChanges() {
        console.log('ngOnChanges');
        this.currentCategory = this.categoryId;
        this.isClicked = [];
        this.isClicked[this.categoryId] = true;
        this.listSandBox.getActiveCategory(this.currentCategory);
    }
    // initially calls subscribe method
    ngOnInit() {
        // this.showSubcategories[0]=false
      this.specialDealValue=  localStorage.getItem('specialdeal')
      console.log("===========>",this.specialDealValue)
        
        this.route.params.subscribe(data => {
            if (data) {
                console.log('routepath', data.id);
                this.categorySlug = data.id;
                this.categoryFilter(data.id)
            }
        });
        this.subCategory = this.categories;
        
        console.log('this.subCategory', this.categories);
        this.categoryFilter(this.categoryId)
    }
    // filtercategory(){
    //     this.filteredArray = []
    //     if(this.subCategory){
    //         this.subCategory.forEach((item:any)=>{
            

    //             let step1 = (item?.children).forEach((item1: any) => {
    //                 if (item1 && item1.categorySlug === this.categoryId) {
    //                     if (!this.filteredArray.some(matchingItem => matchingItem.categoryId === item1.categoryId)) {
    //                         this.filteredArray.push(item1);
    //                     }
    //                 }
    //             });
    //                     })
    //     }

    //     console.log('items',this.filteredArray)
    // }
    subcategorys(){
        debugger
        this.visible =true
    }
    toggleSubcategories(index: number): void {
        this.showSubcategories[index] = !this.showSubcategories[index];
        
        
    }

    categoryFilter(i) {
        console.log('categoryFilter', i);
        const params = {
          categorySlug: i,
          settingsId: environment.settingsId
        };
        this.listsService.getSubCategoryList(params)
          .subscribe((res: any) => {
            this.Category = res?.categoryDataId?.children;
            console.log('itemsssssss',this.Category)
          });
          const param = {
            categorySlug: i,
            settingsId: environment.settingsId,
            specialdeal:this.specialDealValue
        }

        this.listsService.getSubCategoryList_new(param).subscribe((res: any) => {
            console.log("paramssss======================================================================================4", params)
            this.Category = res?.categoryDataId?.children;
            this.SideCategory = res?.categoryDataId?.children;
            console.log('itemsssssss',this.SideCategory)
          });
      }
    ngDoCheck() {
        console.log('ngDoCheck', this.categories);
        if (this.categories && !this.mainCategories) {
            this.subCategory = this.categories;
            console.log('this.subCategory', this.categories);

            this.mainCategories = this.categories.filter(category => category.parentId === this.categoryParentId);
            // this.sidecategories.filter()
            console.log("main category",this.mainCategories)
        }
       
    }
    // emit the category id
    public changeCategory(id, activeId, slug) {
        console.log('activeId', activeId,slug);
        this.router.navigate(['/products/' + slug]);
        this.isClicked = [];
        const params: any = {};
        params.id = id;
        params.slug = slug;
        if (id === +this.currentCategory) {
            this.activecategory = '';
            this.listSandBox.removeActiveCategory();
            this.change.emit('');

        } else {
            this.isClicked[id] = true;
            this.currentCategory = id;
            this.activecategory = activeId;
            this.change.emit(params);
        }
    }
    subscribe() {
        this.subscriptions.push(this.listSandBox.subCategoryList$.subscribe(data => {
            if (data && data.length > 0) {
                this.subCategory = data;
                console.log('this.subCategory2', this.subCategory);
                if (this.subCategory.length > 0) {
                    this.subCategory.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            item.children.forEach(list => {
                                if (list.categorySlug === this.categorySlug) {
                                    this.activecategory = item.categoryId;
                                    console.log('active category', this.activecategory);
                                }
                            });
                        }
                    });
                }
            } else {
                this.subCategory = this.categories;
            }
        }));
        console.log('--------data',this.categoryId)
    }
    // OnDestroy Unsubscribe the old subscribed values
    ngOnDestroy() {
        this.subscriptions.forEach(each => {
            each.unsubscribe();
        });
    }
}

